import "./solicitor-dashboard.scss";
import { Separator } from "../../../components/separator";
import { CaseTable } from "../../../components/solicitor/dashboard/case-table/case-table";
import useIsMobile from "../../../hooks/use-is-mobile";
import ApplicationCooDashboardLayout from "../../../layout/application-coo-dashboard-layout";
import { useAppSelector } from "../../../redux/hook";

export function SolicitorDashboard() {
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);
  const { isMobile } = useIsMobile();

  return (
    <ApplicationCooDashboardLayout bannerTitle="Change in Flat Ownership Dashboard (Solicitor)">
      <div className="polymer-dashboard" style={{ ...(isMobile ? { paddingBottom: 0 } : {}) }}>
        <div className="polymer-dashboard__greetings" style={{ marginBottom: 32 }}>
          <h4 style={{ fontSize: isMobile ? 26 : 28 }}>Hello {loginUser.name.toUpperCase() ?? "User"}!</h4>
        </div>
        <Separator style={{ marginTop: 53, marginBottom: 53 }} variant="dashed" title="Dashboard" />
        <div className="polymer-dashboard__background" style={{ ...(isMobile ? { borderRadius: 0 } : {}) }}>
          <CaseTable />
        </div>
      </div>
    </ApplicationCooDashboardLayout>
  );
}
